/**
 * External Dependencies
 */
import Alpine from 'alpinejs';
import Flickity from 'flickity';

window.Alpine = Alpine;

Alpine.start();

/**
 * Edition header gallery (shown when an edition has a gallery but no header image).
 */
document.querySelectorAll('[data-slider]').forEach((element) => {
  new Flickity(element, {
    cellAlign: 'left',
    contain: true,
    autoPlay: 6000,
    adaptiveHeight: true,
  });
});
